<template>
  <div class="content md flex-box vertical">
    <div class="space-energy">
      <a-card :bordered="false" title="能耗数据`">
        <div class="piece-area-ctx flex-box align-center justify-between">
          <div class="piece-view">
            <div class="piece-view-value">12562KW·H</div>
            <div class="piece-view-title">本年总能耗</div>
          </div>
          <div class="piece-view">
            <div class="piece-view-value">986KW·H</div>
            <div class="piece-view-title">本月总能耗</div>
          </div>
        </div>
      </a-card>
    </div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="办公室能耗">
        <data-list
            ref="dataList"
            class="flex-grow"
            :data="officeEnergy"
            entity-name="能耗"
            :add-btn="false"
            hide-action
            :columns="columns"
            :search-key-type="{ name: 1 }"
        >
          <template v-slot:query="{form}">
            <a-form-model-item label="">
              <a-radio-group v-model="dateType" button-style="solid">
                <a-radio-button :value="d.value" v-for="d in dateOptions" :key="d.value">{{ d.label }}</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="">
              <a-input v-model="form.name" placeholder="输入办公室、会议室名称搜索" allowClear style="width: 240px"></a-input>
            </a-form-model-item>
          </template>
        </data-list>
      </a-tab-pane>
      <a-tab-pane key="2" tab="会议室能耗">
        <data-list
            ref="dataList"
            class="flex-grow"
            :data="meetingEnergy"
            entity-name="能耗"
            :add-btn="false"
            hide-action
            :columns="columns"
            :search-key-type="{ name: 1 }"
        >
          <template v-slot:query="{form}">
            <a-form-model-item label="">
              <a-radio-group v-model="dateType" button-style="solid">
                <a-radio-button :value="d.value" v-for="d in dateOptions" :key="d.value">{{ d.label }}</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="">
              <a-input v-model="form.name" placeholder="输入办公室、会议室名称搜索" allowClear style="width: 240px"></a-input>
            </a-form-model-item>
          </template>
        </data-list>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
const officeList = ["数字赋能中心", "华严阁", "联灯阁", "大悲楼", "云中轩"];

export default {
  name: "SpaceEnergy",
  data() {
    return {
      list: [],
      columns: [
        { title: "办公室名称", dataIndex: "name" },
        { title: "能耗(kw·h)", dataIndex: "value" },
      ],
      dateOptions: [
        { value: 1, label: '今日' },
        { value: 2, label: '本周' },
        { value: 3, label: '本月' },
        { value: 4, label: '本年' },
      ],
      dateType: 1,
    }
  },
  computed: {
    dateOffset() {
      const dateType = this.dateType;
      let num = 1;
      const now = new Date();
      switch (dateType) {
        case 2:
          num = now.getDay() === 0 ? 7 : now.getDay();
          break;
        case 3:
          num = now.getDate();
          break;
        case 4:
          num = Math.round((new Date(now.getFullYear(), now.getMonth(), now.getDate()) - new Date(now.getFullYear(), 0, 1)) / (24 * 60 * 60 * 1000));
          break;
      }
      return num;
    },
    officeEnergy() {
      const num = this.dateOffset;
      return officeList.map((item) => {
        const total = new Array(num).fill(0).map(() => 3 + Math.random() * 5).reduce((a, b) => a + b);
        return {
          name: item,
          value: Math.round(total * 100) / 100
        }
      });
    },
    meetingEnergy() {
      const num = this.dateOffset;
      return officeList.map((item) => {
        const total = new Array(num).fill(0).map(() => 1 + Math.random() * 5).reduce((a, b) => a + b);
        return {
          name: item,
          value: Math.round(total * 100) / 100
        }
      });
    }
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
@import url("../../common/less/safe.less");

.space-energy {
  flex-shrink: 0;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
}

</style>
